import {  GET_WIX_CATEGORIES, GET_SINGLE_WIX_CATEGORY } from "../../actions/type";

  // activity intial state
  const initialCategory = {
    categories: null,
    categoryForEdit:null,
    isLoading: true,
    isEditLoading: true,

  };
  
  export const reducer = (state = initialCategory, action) => {
    switch (action.type) {
      case GET_WIX_CATEGORIES: {
        const categories = action.payload;
        return {
          ...state,
          categories: categories,
          isLoading: false,

        };
      }
      case GET_SINGLE_WIX_CATEGORY: {
        const categoryForEdit = action.payload;
        return {
          ...state,
          categoryForEdit,
          isEditLoading: false,
        };
      }
      default:
        return state;
    }
  };